export default __webpack_public_path__ + "static/media/flowLOGO2.9ca9ca5a.png";